export default "__VITE_ASSET__rvDuw40b__"